import React from 'react';
import { getLocalStorageKey } from '../common/common';

function FormattedCurrencyNumberCustom(props) {
  const currPorps = props;
  const value = currPorps.value;
  const userLocale = getLocalStorageKey('locale');
  const direction = currPorps.currencyDirection ? currPorps.currencyDirection : 'left';
  // const LOCAL_STORAGE_KEY = 'locale';
  // const persistedState = localStorage.getItem(LOCAL_STORAGE_KEY);
  // const store = persistedState ? JSON.parse(persistedState) : {};
  // const user = store.user;
  // const currency = user.currency;
  const thousandSep = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
    .format(value);
  return (
    <span className="custom-formated-currency">
      { direction === 'right' &&
        <span>
          {thousandSep}
        </span>
      }
      { direction !== 'right' &&
        <span>
          {thousandSep}
        </span>
      }
    </span>
  );
}
export default FormattedCurrencyNumberCustom;
